export var CredentialsProfileSortField;
(function (CredentialsProfileSortField) {
    CredentialsProfileSortField["CREDENTIALS_PROFILE_SORT_FIELD_CREATED_AT"] = "createdAt";
    CredentialsProfileSortField["CREDENTIALS_PROFILE_SORT_FIELD_UPDATED_AT"] = "updatedAt";
    CredentialsProfileSortField["CREDENTIALS_PROFILE_SORT_FIELD_NAME"] = "name";
})(CredentialsProfileSortField || (CredentialsProfileSortField = {}));
